export const FONT_ROOT_FOLDER = process.env.PUBLIC_URL + "/fonts/";
export const FONT_OPEN_SANS_BOLD = FONT_ROOT_FOLDER + "open_sans_bold.ttf";
export const FONT_OPEN_SANS_REGULAR =
  FONT_ROOT_FOLDER + "open_sans_regular.ttf";
